export const VueProgressBar = {
  data() {
    return {
      router_finish: [],
      finishing: false
    }
  },
  created() {
    this.$Progress.start()
    this.$router.beforeEach((to, from, next) => {
      if (this.is_finish(to.name)) return next()
      if (this.finishing == true) return next()
      this.finishing = true
      this.$Progress.start()
      next()
    })
    this.$router.afterEach(to => {
      this.$Progress.finish()
      if (this.is_finish(to.name)) return
      this.finishing = true
      //1秒鐘的過渡狀態處理(完成後1秒才可再次處發)
      setTimeout(() => {
        this.finishing = false
      }, 800)
      this.router_finish.push(to.name)
    })
  },
  mounted() {
    this.$Progress.finish()
  },
  methods: {
    is_finish(name) {
      for (let i = 0; i < this.router_finish.length; i++) {
        if (this.router_finish[i] == name) return true
      }
    }
  }
}
